import { SvgIcon } from '@mui/material'

export default props => (
  <SvgIcon {...props}>
    <path d="M8 7c0 .552.448 1 1 1h12c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1H9c-.552 0-1 .448-1 1v1z" />
    <rect width="15" height="3" rx="1" transform="matrix(1 0 0 -1 5 13)" />
    <rect width="14" height="3" rx="1" transform="matrix(1 0 0 -1 2 18)" />
  </SvgIcon>
)
